import Icon from '@/components/ui/AppIcon';

export default function ContactInfoCards() {
  const contactInfo = [
    {
      id: 'phone',
      icon: 'PhoneIcon',
      title: 'Call Us',
      details: ['9763150150', '9321111170'],
      link: 'tel:9763150150',
    },
    {
      id: 'email',
      icon: 'EnvelopeIcon',
      title: 'Email Us',
      details: ['contact@classic24digital.com'],
      link: 'mailto:contact@classic24digital.com',
    },
    {
      id: 'location',
      icon: 'MapPinIcon',
      title: 'Visit Us',
      details: ['Classic24 Digital Solutions', 'View on Google Maps'],
      link: 'https://www.google.com/maps/place/Classic24+Digital+Solutions/@19.2212296,73.162009,17z',
    },
  ]

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16 reveal">
      {contactInfo.map((info) => (
        <a
          key={info.id}
          href={info.link}
          target={info.id === 'location' ? '_blank' : undefined}
          rel={info.id === 'location' ? 'noopener noreferrer' : undefined}
          className="group bg-zinc-900 border border-zinc-800 rounded-2xl p-8 hover:border-amber-500/30 transition-all glow-hover hover:scale-105"
        >
          <div className="w-14 h-14 mb-6 flex items-center justify-center text-amber-500 bg-amber-500/10 rounded-xl group-hover:bg-amber-500 group-hover:text-white transition-all">
            <Icon name={info.icon as any} size={28} />
          </div>
          <h3 className="text-xl font-bold text-white mb-3">{info.title}</h3>
          {info.details.map((detail, idx) => (
            <p
              key={idx}
              className="text-zinc-400 group-hover:text-amber-500 transition-colors"
            >
              {detail}
            </p>
          ))}
        </a>
      ))}
    </div>
  )
}